// components/CartContext.jsx
import React, { createContext, useState, useEffect } from "react";

export const CartContext = createContext();

// components/CartContext.jsx
export const CartProvider = ({ children }) => {
    const [cartItems, setCartItems] = useState([]);
    console.log("cart items", cartItems)

    const addToCart = (product, quantity = 1, selectedColor = null, selectedSize = null) => {
        // Find the correct variant by selectedColor
        const variant = product.variants?.find(v => v.color === selectedColor);
        console.log(variant, "variant");

        // Find the correct size within the variant
        const sizeObj = variant?.sizes?.find(s => s.size === selectedSize);
        console.log(sizeObj, "sizeObj");


        const price = sizeObj?.price?.mrp || variant?.sizes?.[0]?.price?.mrp || 0;
        console.log(price, "price");


        setCartItems((prev) => {
            const existingItem = prev.find(
                (item) =>
                    item.product_id === product.product_id &&
                    item.selectedColor === selectedColor &&
                    item.selectedSize === selectedSize
            );

            if (existingItem) {
                return prev.map((item) =>
                    item.product_id === product.product_id &&
                        item.selectedColor === selectedColor &&
                        item.selectedSize === selectedSize
                        ? { ...item, quantity: item.quantity + quantity }
                        : item
                );
            } else {
                return [
                    ...prev,
                    {
                        ...product,
                        quantity,
                        selectedColor,
                        selectedSize,
                        price,
                    },
                ];
            }
        });
    };


    const removeFromCart = (productId, selectedColor = null, selectedSize = null) => {
        setCartItems((prev) =>
            prev.filter(
                (item) =>
                    item.product_id !== productId ||
                    item.selectedColor !== selectedColor ||
                    item.selectedSize !== selectedSize
            )
        );
    };

    const clearCart = () => setCartItems([]);

    // LocalStorage
    useEffect(() => {
        const storedCart = localStorage.getItem("cart");
        if (storedCart) setCartItems(JSON.parse(storedCart));
    }, []);

    useEffect(() => {
        localStorage.setItem("cart", JSON.stringify(cartItems));
    }, [cartItems]);

    return (
        <CartContext.Provider
            value={{ cartItems, addToCart, removeFromCart, clearCart }}
        >
            {children}
        </CartContext.Provider>
    );
};

